import React, { useState } from 'react';
import { Button, Form, Container, Row, Col, Alert } from 'react-bootstrap';
import HubspotLogo from '../../assets/images/HubSpot.svg';

const Hubspot = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showError, setShowError] = useState(false);

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        if (email !== 'qawsertyu@gmail.com') {
            setShowError(true);
        } else {
            setShowError(false);
        }
    };
    const isLoginDisabled = email === '' || password === '';
    return (
        <div className="hubspot">
            <Row>
                <Col md={12} style={{ width: '512px' }}>
                    <div className="d-flex justify-content-center align-items-center mb-4">
                        <img src={HubspotLogo} className="hubspot-logo" />
                    </div>
                    <Form onSubmit={handleLogin} className="hubspot-form">
                        <Form.Group controlId="formEmail">
                            <Form.Label className="hubspot-label">Email address</Form.Label>
                            <Form.Control
                                type="email"
                                // placeholder="Enter email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formPassword">
                            <Form.Label className="hubspot-label">Password</Form.Label>

                            <Button
                                type="submit"
                                className="w-100 hubspot-button hubspot-button_link mb-1"
                            >
                                Show Password
                            </Button>

                            <Form.Control
                                type="password"
                                // placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />

                            <Button
                                type="submit"
                                className="w-100 hubspot-button hubspot-button_link mb-1"
                            >
                                Forgot my password
                            </Button>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicCheckbox">
                            <Form.Check
                                type="checkbox"
                                label="Remember me"
                                style={{ fontSize: '16px', fontWeight: '400' }}
                            />
                        </Form.Group>
                        {showError && (
                            <Alert variant="danger">
                                <h3>That email address doesn’t exist.</h3>
                                <p>
                                    You've entered an invalid password. For more detail on why this
                                    could be happening, please read{' '}
                                    <a
                                        href="http://help.hubspot.com/articles/KCS_Article/Account/Why-can-t-I-log-into-HubSpot"
                                        target="_blank"
                                        rel="noopener"
                                        className="link-style"
                                    >
                                        this article
                                    </a>
                                </p>
                            </Alert>
                        )}
                        <Button
                            type="submit"
                            className={`w-100 hubspot-button ${
                                isLoginDisabled
                                    ? 'hubspot-button_disabled'
                                    : 'hubspot-button_primary'
                            }`}
                        >
                            Log in
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default Hubspot;
